// store/auth.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  displayName: string
  email: string
  jobTitle?: string
  photoUrl?: string | null
  department?: string
  officeLocation?: string
  givenName?: string
}

interface AuthState {
  isAuthenticated: boolean
  user: User | null
  authError: string | null
  authInProgress: boolean
  setIsAuthenticated: (isAuthenticated: boolean) => void
  setUser: (user: User | null) => void
  setAuthError: (error: string | null) => void
  setAuthInProgress: (inProgress: boolean) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      authError: null,
      authInProgress: false,
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setUser: (user) => set({ user }),
      setAuthError: (authError) => set({ authError }),
      setAuthInProgress: (authInProgress) => set({ authInProgress }),
      clearAuth: () =>
        set({
          isAuthenticated: false,
          user: null,
          authError: null,
          authInProgress: false,
        }),
    }),
    {
      name: 'auth-storage',
      // We only persist non-sensitive state information
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        // We don't persist error or progress state
      }),
    },
  ),
)
